export default {
  title: {
    id: 'recommendation_cross_sell_title',
    defaultMessage: 'Plays nice with',
  },
  titleAccessories: {
    id: 'recommendation_cross_sell_accessories_title',
    defaultMessage: 'Make it last (even longer)',
  },
}
